import { get } from "svelte/store"
import { applySearchParam } from "./applySearchParam.js";

/**
 *
 * @param GanttStore
 * @param {URLSearchParams} searchParams
 * @returns {Promise<void>}
 */
async function applySearchParamsToGanttStore(GanttStore, searchParams) {
  if (searchParams.get("style")) {
    const styleObjects = get(GanttStore.StyleObjects) ?? []
    const specifiedStyleName = searchParams.get("style")
    const specifiedStyleObject = styleObjects.find((s) => s.StyleName == specifiedStyleName)
    // check if the specified style name is valid
    if (specifiedStyleObject) {
      GanttStore.CurrentStyle.set(specifiedStyleObject)
    }
  }
}

function subscribeGanttStore(GanttStore) {
  GanttStore.CurrentStyle.subscribe(styleObject => {
    applySearchParam("style", styleObject.StyleName)
  })
}

/**
 *
 * @param GanttStore
 * @param {URLSearchParams | null} initialSearchParams
 * @returns {Promise<void>}
 */
export async function connectSearchParamsToGanttStore(GanttStore, initialSearchParams = new URLSearchParams(window.location.search)) {
  await applySearchParamsToGanttStore(GanttStore, initialSearchParams)

  subscribeGanttStore(GanttStore)
}
